import * as React from 'react';
export const woocommerceSvg = React.forwardRef(function woocommerceSvgInner(
  props,
  ref,
) {
  return /*#__PURE__*/ React.createElement(
    'svg',
    {
      ...props,
      ref: ref,
    },
    /*#__PURE__*/ React.createElement('path', {
      fill: '#7F54B3',
      d: 'M0 0h32v32H0z',
    }),
    /*#__PURE__*/ React.createElement('path', {
      fillRule: 'evenodd',
      clipRule: 'evenodd',
      d: 'M7.048 9.627h17.903a2.018 2.018 0 0 1 1.449.614 2.133 2.133 0 0 1 .6 1.48v6.98c0 .274-.053.546-.156.8a2.097 2.097 0 0 1-.444.68 2.041 2.041 0 0 1-1.449.612h-6.42L19.41 23l-3.88-2.207H7.047a2.027 2.027 0 0 1-1.447-.614 2.117 2.117 0 0 1-.6-1.478v-6.98c0-.555.216-1.087.6-1.48a2.027 2.027 0 0 1 1.448-.614Z',
      fill: '#fff',
    }),
    /*#__PURE__*/ React.createElement('path', {
      d: 'M6.022 11.611a.762.762 0 0 1 .576-.289c.467-.032.736.191.805.671.288 1.947.597 3.6.926 4.959l2.017-3.89c.182-.352.413-.538.692-.558.404-.029.657.232.758.783.19 1.089.481 2.157.87 3.19.243-2.37.647-4.083 1.214-5.14a.716.716 0 0 1 .608-.413.801.801 0 0 1 .58.185.716.716 0 0 1 .281.539.8.8 0 0 1-.088.45c-.36.675-.655 1.8-.886 3.371-.23 1.518-.314 2.705-.254 3.561a1.15 1.15 0 0 1-.107.611.585.585 0 0 1-.49.338c-.243.018-.485-.098-.729-.346-.855-.89-1.535-2.215-2.038-3.973a702.538 702.538 0 0 1-1.33 2.69c-.54 1.054-1.003 1.595-1.389 1.622-.25.018-.464-.195-.64-.64-.472-1.22-.98-3.582-1.52-7.085a.81.81 0 0 1 .144-.636Z',
      fill: '#7F54B3',
    }),
    /*#__PURE__*/ React.createElement('path', {
      fillRule: 'evenodd',
      clipRule: 'evenodd',
      d: 'M25.703 13.261a2.03 2.03 0 0 0-.603-.651 2.139 2.139 0 0 0-.836-.345 2.5 2.5 0 0 0-.49-.05c-.862 0-1.566.43-2.113 1.29a4.433 4.433 0 0 0-.7 2.427c0 .664.145 1.233.434 1.708.148.257.354.48.603.652.25.172.535.29.837.344.16.033.324.05.488.05.871 0 1.576-.43 2.113-1.289a4.489 4.489 0 0 0 .701-2.441c0-.665-.144-1.23-.434-1.694Zm-1.136 2.392c-.123.564-.351.99-.684 1.275-.265.228-.507.32-.727.278-.22-.042-.397-.228-.53-.557a2.143 2.143 0 0 1-.159-.785c0-.212.021-.424.066-.632.086-.368.247-.716.475-1.024.3-.421.613-.598.939-.53.22.042.396.227.529.555.101.25.155.516.157.784.002.213-.02.427-.066.636ZM19.4 12.61c.269.172.492.394.653.652h.007c.313.465.47 1.03.47 1.694a4.252 4.252 0 0 1-.765 2.441c-.582.86-1.344 1.29-2.288 1.29a2.924 2.924 0 0 1-.528-.051 2.411 2.411 0 0 1-.905-.344 2.093 2.093 0 0 1-.653-.652c-.313-.475-.47-1.044-.47-1.708a4.184 4.184 0 0 1 .759-2.427c.59-.86 1.352-1.29 2.286-1.29.178.001.355.018.53.05.326.055.634.173.904.345Zm-1.32 4.32c.363-.286.61-.712.744-1.277v-.002c.048-.208.072-.42.071-.633a2.001 2.001 0 0 0-.172-.783c-.142-.328-.333-.513-.571-.556-.354-.068-.692.109-1.015.529-.246.308-.42.656-.514 1.024a2.7 2.7 0 0 0-.072.632c.004.269.062.534.172.785.143.33.334.517.572.559.237.042.5-.05.786-.278Z',
      fill: '#7F54B3',
    }),
  );
});
woocommerceSvg.defaultProps = {
  width: '32',
  height: '32',
  viewBox: '0 0 32 32',
  fill: 'none',
  xmlns: 'http://www.w3.org/2000/svg',
};
export var woocommerce = {
  category: 'brand',
  colorable: false,
  name: 'woocommerce',
  svg: woocommerceSvg,
};
